import numberDisplay from "../../../../components/numberDisplay/numberDisplay";
import { connect } from "react-redux";

export default connect(state => {
  let isPayingMembers = state.membership.isPayingMembers;
  let tooltip = isPayingMembers ? state.membership.payingMembersNumber.newMembers.tooltip : state.membership.newMemberships.tooltip;
  return {
    value: state.membership.newMemberships.newMemberships,
    url: state.membership.newMemberships.url,
    tooltipId: "newMembersTooltip",
    toolTipContent: tooltip,
    disableAnimation: state.membership.currentUser.qa
  };
})(numberDisplay);
